// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r7-1";
export var messageSideRight = "_r7-2";
export var subscribeToBackInStockBubbleContainer = "_r7-0";